// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://scxnjtjdefpoeudjwmbe.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNjeG5qdGpkZWZwb2V1ZGp3bWJlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ2NTkzNjMsImV4cCI6MjA2MDIzNTM2M30.gP2u-c1wEywDMFIEkfVI-GVr4vmIhB-qWuaxeieTzXU";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: localStorage
    }
  }
);